module.exports = __webpack_public_path__ + "static/media/BG_2.0cc4903a.webp";